import React from "react";
import { bool, oneOfType, string, element, func } from "prop-types";
import cx from "classnames";

const propTypes = {
  /** Tabpanel id */
  id: string.isRequired,
  /** Active state */
  isActive: bool,
  /** Disable the tabpanel and its tab */
  isDisabled: bool,
  /** Tab content */
  /** Custom tab renderer. Passes props as function parameter */
  renderTab: func,
  tab: oneOfType([string, element]),
};

const CLASS_ROOT = "tab-panels__panel";

const TabPanel = ({
  children,
  className,
  isActive,
  id,
  isDisabled,
  renderTab,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    {
      "is-active": isActive,
    },
    className
  );

  return (
    <div id={id} className={classes} role="tabpanel" tabIndex="0" {...other}>
      {children}
    </div>
  );
};

TabPanel.displayName = "TabPanel";
TabPanel.propTypes = propTypes;

export default TabPanel;
